import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-144c3b33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-recommendations" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Редактировать ")

import { computed, PropType, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import RecommendationsEdition from '@/widgets/WReportRecommendations/components/RecommendationsEdition.vue'
import { RECOMMENDATIONS_MODE } from '@/widgets/WReportRecommendations/constants/recommendations'
import { RecommendationsModeType } from '@/widgets/WReportRecommendations/types/recommendations.type'
import { ERecommendations } from '@/entities/ERecommendations'
import { ConsultationType } from '@/shared/types'
import { useOrganizationModules } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  props: {
  consultation: Object as PropType<ConsultationType>,
  isPlaqueReport: Boolean,
  isPeriodontalReport: Boolean,
},
  emits: ['updated'],
  setup(__props, { emit }) {

const props = __props




const route = useRoute()

const { organizationModules } = useOrganizationModules()

const recommendationsMode = ref<string>()

const isShowRecommendations = computed(() => {
  if (props.isPlaqueReport) {
    return organizationModules.value.indexOf('plaque') > -1
  } else {
    return organizationModules.value.indexOf('periodontology') > -1
  }
})
const reportId = computed<string>(() => route.params.reportId as string)

function setRecommendationMode() {
  if (
    props.consultation.consultations.length ||
    props.consultation.reCleaning
  ) {
    recommendationsMode.value = RECOMMENDATIONS_MODE.saved
  } else {
    recommendationsMode.value = RECOMMENDATIONS_MODE.edit
  }
}

watch(props.consultation, setRecommendationMode)
watch(reportId, setRecommendationMode)

const handleChangeRecommendationsMode = (
  mode: RecommendationsModeType
): void => {
  recommendationsMode.value = mode
  if (recommendationsMode.value === RECOMMENDATIONS_MODE.saved) {
    emit('updated')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (recommendationsMode.value === _unref(RECOMMENDATIONS_MODE).edit)
      ? (_openBlock(), _createBlock(RecommendationsEdition, {
          key: 0,
          consultation: __props.consultation,
          "is-plaque-report": __props.isPlaqueReport,
          "is-periodontal-report": __props.isPeriodontalReport,
          onSaved: _cache[0] || (_cache[0] = ($event: any) => (handleChangeRecommendationsMode(_unref(RECOMMENDATIONS_MODE).saved)))
        }, null, 8, ["consultation", "is-plaque-report", "is-periodontal-report"]))
      : (_openBlock(), _createBlock(_unref(ERecommendations), {
          key: 1,
          consultation: __props.consultation,
          "is-plaque-report": __props.isPlaqueReport,
          "is-periodontal-report": __props.isPeriodontalReport
        }, {
          edit: _withCtx(() => [
            _withDirectives(_createElementVNode("button", {
              class: "report-recommendations__edit",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeRecommendationsMode(_unref(RECOMMENDATIONS_MODE).edit)))
            }, [
              _createVNode(_component_icon_template, {
                class: "report-recommendations__edit-icon",
                height: "10",
                name: "edit",
                width: "10"
              }),
              _hoisted_2
            ], 512), [
              [_vShow, _unref(isShowRecommendations)]
            ])
          ]),
          _: 1
        }, 8, ["consultation", "is-plaque-report", "is-periodontal-report"]))
  ]))
}
}

})